import {
  ButtonRow,
  DetailsList,
  DetailsListItem,
  FormButton,
  RevealTypography,
  useModal,
} from "@synota-io/synota-shared-ui";
import { IUserReceiveConfigurationResponse } from "../../../../api/hooks/useUserReceiveConfiguration";
import { Stack, Typography } from "@mui/material";
import { AchSettingsFormModal } from "../forms/AchSettingsFormModal";
import { generatePath, useMatch, useNavigate, useParams } from "react-router-dom";
import { USER_ACCOUNT_UPDATE_PATH } from "../../../../paths";
import { useEffect } from "react";

export const UserBluePenguinReceiveConfiguration = ({
  configuration,
}: {
  configuration: IUserReceiveConfigurationResponse;
}) => {
  const navigate = useNavigate();
  const modal = useModal();
  const params = useParams();

  const match = useMatch({ path: USER_ACCOUNT_UPDATE_PATH, end: true });

  useEffect(() => {
    if (match && !modal.open) {
      modal.onOpen();
    }
  }, [match, modal]);

  const isBluePenguin = configuration && "BluePenguinConfiguration" in configuration;

  if (!isBluePenguin) {
    return null;
  }

  return (
    <Stack gap={2}>
      <Typography variant="h6">Bank Account</Typography>
      <DetailsList>
        <DetailsListItem title="ACH Routing Number">
          <RevealTypography hint hintLength={2}>
            {configuration.BluePenguinConfiguration.ach_routing_number || ""}
          </RevealTypography>
        </DetailsListItem>
        <DetailsListItem title="ACH Account Number">
          <RevealTypography hint hintLength={2}>
            {configuration.BluePenguinConfiguration.ach_account_number || ""}
          </RevealTypography>
        </DetailsListItem>

        {configuration.BluePenguinConfiguration.additional_info ? (
          <>
            <DetailsListItem title="Account Type">
              {configuration.BluePenguinConfiguration.additional_info.account_type}
            </DetailsListItem>
            <DetailsListItem title="Company Name">
              {configuration.BluePenguinConfiguration.additional_info.company_name}
            </DetailsListItem>
            <DetailsListItem title="City">
              {configuration.BluePenguinConfiguration.additional_info.city}
            </DetailsListItem>
            <DetailsListItem title="State">
              {configuration.BluePenguinConfiguration.additional_info.state}
            </DetailsListItem>
            <DetailsListItem title="Country Code">
              {configuration.BluePenguinConfiguration.additional_info.country_code}
            </DetailsListItem>
            <DetailsListItem title="Zip Code">
              {configuration.BluePenguinConfiguration.additional_info.postal_code}
            </DetailsListItem>
            <DetailsListItem title="Address">
              {configuration.BluePenguinConfiguration.additional_info.address}
            </DetailsListItem>
          </>
        ) : null}
      </DetailsList>
      <ButtonRow>
        <FormButton
          type="button"
          variant="contained"
          size="small"
          onClick={() =>
            params.id && navigate(generatePath(USER_ACCOUNT_UPDATE_PATH, { id: params.id }))
          }
        >
          Update Bank Account
        </FormButton>
      </ButtonRow>
      {match ? (
        <AchSettingsFormModal
          {...modal}
          onClose={() =>
            navigate(
              { pathname: ".." },
              { preventScrollReset: true, relative: "path", replace: true },
            )
          }
        />
      ) : null}
    </Stack>
  );
};
